import settingsRouterPaths from './settingsRouterPaths';

export default settingsRouterPaths;
